import './ZoneBlockSelection.css';

// Component Zone selection
function ZoneBlockSelection() {
    return <div id="zone_blocks_selection"></div>
}

export default ZoneBlockSelection;